import React from 'react';
import { Heading } from '@balance-web/heading';

import { useBottomDrawer } from './context';

export const Title = ({ children }: { children: string }) => {
  const { headingId } = useBottomDrawer();

  return (
    <Heading id={headingId} level="4">
      {children}
    </Heading>
  );
};
